import { Box, Typography } from '@mui/material'
import { Inbox } from '@mui/icons-material'

const EmptyState = ({
  icon: Icon = Inbox,
  title = 'No data',
  description = 'No items to display',
  action,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={6}
      textAlign="center"
    >
      <Box
        sx={{
          backgroundColor: 'grey.100',
          borderRadius: '50%',
          p: 3,
          mb: 2,
        }}
      >
        <Icon sx={{ fontSize: 48, color: 'grey.400' }} />
      </Box>
      <Typography variant="h6" color="text.primary" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" maxWidth={300}>
        {description}
      </Typography>
      {action && <Box mt={3}>{action}</Box>}
    </Box>
  )
}

export default EmptyState
